module.exports = __webpack_public_path__ + "media/src/signin/google_icon-9fedf3fef6b05d01e871dc037354ac27.png";